<div class="dialog-container">
    <header class="dialog-header p-lr20 p-t20" >
        <div  class="flex-row-container">    
            <span class="flex-1 B font18">Context</span>
            <mat-icon class="pointer" aria-hidden="false" (click)="closeDialog()">close</mat-icon>
        </div>    
    </header>
    <main class="dialog-content m-10">
        <div class="row" >
            <div class="column">
                <h1 class="B">App Context</h1>
                <textarea class="textarea-size">{{appContext}}</textarea>
            </div>
            <div class="column">
                <h1 class="B">App Data</h1>
                <textarea class="textarea-size">{{appData}}</textarea>
            </div>
            <div class="column">
                <h1 class="B">UI State</h1>
                <textarea class="textarea-size">{{uiState}}</textarea>
            </div>
        </div>
        <div class="row" >
            <div class="column">
                <h1 class="B">Ref Data</h1>
                <textarea class="textarea-size">{{refData}}</textarea>
            </div>
            <div class="column">
                <h1 class="B">Chart Data</h1>
                <textarea class="textarea-size">{{chartData}}</textarea>
            </div>
            <div class="column">
                <h1 class="B">Models</h1>
                <textarea class="textarea-size"></textarea>
            </div>
        </div>
        <div class="row" >
            
            <div class="column">
                <h1 class="B">User Info</h1>
                <textarea class="textarea-size">{{userInfo}}</textarea>
            </div>
            <div class="column">
                <h1 class="B">Placeholder 1</h1>
                <textarea class="textarea-size"></textarea>
            </div>
            <div class="column">
                <h1 class="B">Placeholder 2</h1>
                <textarea class="textarea-size"></textarea>
            </div>
        </div>
    </main>
    <footer class="flex-col-end m-10">
        <!-- <mat-divider class="divider" style="width: 98%"></mat-divider>
        <div class="flex-row-container m-t15">
            <button mat-button color="primary" (click)="cancelCreatePlan()">Cancel</button>
            <button class="m-lr10" mat-raised-button color="primary" [disabled]="!isProfileValidate" (click)="createPlan()">Create Plan</button>
        </div> -->
    </footer>
  </div>